import { Link } from 'react-router-dom';
import { CheckCircle2, Phone } from 'lucide-react';
import { Button, Card, CardContent } from '@leoclinic/ui';
import { BRAND_COLORS } from '@leoclinic/types';
import { useClinicPortal } from '@/providers/clinic-provider';

export default function ConfirmationPage() {
  const { clinic } = useClinicPortal();

  return (
    <div className="min-h-screen bg-[#F6F3EE] flex items-center justify-center p-4">
      <Card className="max-w-md w-full">
        <CardContent className="pt-8 pb-8 text-center space-y-4">
          <CheckCircle2 className="mx-auto h-16 w-16" style={{ color: BRAND_COLORS.greenDark }} />
          <h1 className="text-xl font-bold">Marcação recebida!</h1>
          <p className="text-muted-foreground text-sm leading-relaxed">
            Obrigado pelo seu pedido. A {clinic?.name ?? 'clínica'} entrará em contacto para confirmar a sua sessão.
          </p>
          {clinic?.phone && (
            <a
              href={`tel:${clinic.phone.replace(/\s/g, '')}`}
              className="inline-flex items-center gap-2 text-sm font-medium"
              style={{ color: BRAND_COLORS.greenDark }}
            >
              <Phone className="h-4 w-4" />
              {clinic.phone}
            </a>
          )}
          <Button asChild className="w-full">
            <Link to="/">Nova marcação</Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
